import MessagesAutoTranslate from './MessagesAutoTranslate';
import SideRightChange from './SideRightChange';
import { PhrasePicker, PhrasePickerProps } from './PhrasePicker';
import { StickerPicker, StickerPickerProps } from './StickerPicker';
import ImageUpload from './ImageUpload';
import VideoUpload, { VideoUploadProps } from './VideoUpload';
import { LazadaFollow } from './LazadaFollow';
import { ShopeeFollow } from './ShopeeFollow';
import { AttachmentUploadAction } from './AttachmentUpload/AttachmentUploadAction';
import KwaiStickerPicker from './KwaiStickerPicker';
import WhatsAppTemplate from './WhatsAppTemplate';
import FileUpload from './FileUpload';
import { useMessageEditorToolbarFeatures } from '../hooks/useMessageEditorToolbar';

export interface ToolbarProps {
  className?: string;
  targetLang: General.Language;
  showSideFold?: boolean;
  conversation: Conversation.Conversation;
  videoUploadProps: Omit<VideoUploadProps, 'targetLang'>;
  phrasePickerProps: Omit<PhrasePickerProps, 'conversation' | 'onSend'>;
  stickerPickerProps: Omit<StickerPickerProps, 'conversation' | 'onSend'>;
  canSendTemplate: boolean;
  extra?: React.ReactNode;
  onSend?: () => void;
}

export const Toolbar = (props: ToolbarProps) => {
  const {
    targetLang,
    showSideFold,
    conversation,
    videoUploadProps,
    phrasePickerProps,
    stickerPickerProps,
    canSendTemplate,
    extra,
    onSend,
  } = props;
  const { channel, followerFlag, controlStatus } = conversation;

  const {
    showAttachmentUpload,
    showPhrasePicker,
    showStickerPicker,
    showVideoUpload,
    showImageUpload,
    showLazadaFollow,
    showShopeeFollow,
    showWaMsgTemplate,
  } = useMessageEditorToolbarFeatures({ channel, followerFlag });

  return (
    <div className="relative flex items-center justify-between gap-4 leading-10 mb-[10px] px-2 border-solid border-b-[var(--fett-fill-200)] border-0 border-b h-10 text-[var(--fett-text-secondary)]">
      {extra}
      <div className="flex items-center justify-center gap-4">
        {showAttachmentUpload && <AttachmentUploadAction conversation={conversation} />}
        {showStickerPicker &&
          (channel === 'KWAI' ? (
            <KwaiStickerPicker onPick={stickerPickerProps.onEmojiChange} />
          ) : (
            <StickerPicker {...stickerPickerProps} conversation={conversation} onSend={onSend} />
          ))}
        {showImageUpload && <ImageUpload onSend={() => onSend && onSend()} />}
        {showVideoUpload && <VideoUpload {...videoUploadProps} targetLang={targetLang} />}
        {showLazadaFollow && <LazadaFollow conversation={conversation} onSend={onSend} />}
        {showShopeeFollow && <ShopeeFollow conversation={conversation} onSend={onSend} />}
        {channel === 'FACEBOOK' && <FileUpload onSend={onSend} />}
      </div>
      <div className="flex items-center justify-center gap-4">
        <MessagesAutoTranslate />
        {showWaMsgTemplate && (
          <WhatsAppTemplate
            conversation={conversation}
            canSent={canSendTemplate && controlStatus}
            onSend={onSend}
          />
        )}
        {showPhrasePicker && (
          <PhrasePicker {...phrasePickerProps} conversation={conversation} onSend={onSend} />
        )}
        {showSideFold && <SideRightChange />}
      </div>
    </div>
  );
};
